import { defineComponent, inject, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import { OrderUi } from '@/fairplayer/primary/order-list/Order.ui';
import { ExclusiveImageVue } from '@/common/primary/fairplayer-image/exclusive-image';
import { FairplayerButtonVue } from '@/common/primary/button';
import { printerBusKey } from '@/common/domain/printer/PrinterBus';
import { exclusiveGift } from '@/common/primary/printable/Printable';
import { ExclusiveOrderUi } from '@/fairplayer/primary/order-list/ExclusiveOrder.ui';
import { OrderPriceVue } from './order-price';
import { useRouter } from 'vue-router';
import { clubRepositoryKey } from '@/fairplayer/domain/club/ClubRepository';
import { fromClub } from '@/fairplayer/primary/club/Club.ui';
import { ImageResolution } from '@/common/primary/ImageResolution';

export default defineComponent({
  name: 'OrderList',

  components: { ExclusiveImageVue, OrderPriceVue, FairplayerButtonVue },

  props: {
    orderList: {
      type: Array as PropType<OrderUi[]>,
      required: true,
    },
  },

  setup(props) {
    const { t } = useI18n();
    const router = useRouter();

    const clubRepository = inject(clubRepositoryKey)!;
    const printerBus = inject(printerBusKey)!;

    const club = fromClub(clubRepository.getCurrentClub());
    const hasOrders = () => props.orderList.length > 0;

    const goToMarketplace = () => {
      router.push({ name: 'marketplace' });
    };

    const goToDonationPage = () => {
      router.push({ name: 'donationPage' });
    };

    const print = (exclusive: ExclusiveOrderUi) => {
      const printable = exclusiveGift();
      printerBus.print({ component: printable, options: { exclusive } });
    };

    return {
      ImageResolution,
      goToMarketplace,
      goToDonationPage,
      hasOrders,
      print,
      club,
      t,
    };
  },
});
